import { get } from "lodash-es";
import {
  type Control,
  Controller,
  type FieldError,
  type FieldErrors,
  type FieldPath,
  type FieldValues,
} from "react-hook-form";

import {
  BlDatePicker,
  type BlDatePickerProps,
} from "Shared/Inputs/BlDatePicker";

export type BlFormDatePickerProps<FormType extends FieldValues> = Omit<
  BlDatePickerProps,
  "value" | "fieldError" | "name"
> & {
  name: FieldPath<FormType>;
  control: Control<FormType>;
  errors: FieldErrors<FormType>;
  /** Shorthand for labelProps.label */
  label?: string;
  onChange?: (date: Date | null) => void;
};

export const BlFormDatePicker = <T extends FieldValues>({
  name,
  control,
  errors,
  label,
  labelProps,
  onChange: externalOnChange,
  ...rest
}: BlFormDatePickerProps<T>): React.ReactNode => {
  const mergedLabelProps =
    label !== undefined ? { ...labelProps, label } : labelProps;
  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange: controllerOnChange, value } }) => (
        <BlDatePicker
          name={name}
          value={value}
          onChange={(date) => {
            controllerOnChange(date);
            externalOnChange?.(date);
          }}
          labelProps={mergedLabelProps}
          fieldError={get(errors, name as string) as FieldError | undefined}
          {...rest}
        />
      )}
    />
  );
};
